import { render, staticRenderFns } from "./CmgLoyaltyPepper.vue?vue&type=template&id=1525b1d2&scoped=true&lang=pug"
import script from "./cmg-loyalty-pepper.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-pepper.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyPepper.vue?vue&type=style&index=0&id=1525b1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1525b1d2",
  null
  
)

export default component.exports